<template>
  <div id="app" v-horizontal-screen>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import store from './store'

export default {
  name: 'App',

  created() {
    this.getUserAgent()
  },

  methods: {
    getUserAgent() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        store.commit('setIsPhone', true)
      } else {
        store.commit('setIsPhone', false)
      }
    }
  }
}
</script>

<style>
* {
  -webkit-text-size-adjust: none;
}

* {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;
}
</style>
